import { SITE } from "@/config/site";
import { Reveal } from "./Reveal";

const WhatIs = () => (
  <section id="overview" data-testid="overview-section" className="py-20 sm:py-28">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16 lg:px-8">
      <div>
        <Reveal>
          <p data-testid="overview-tagline" className="text-xs font-bold uppercase tracking-[0.25em] text-brand">
            What is DENSA?
          </p>
          <h2 data-testid="overview-heading" className="mt-4 text-2xl font-bold tracking-tight text-brand-ink sm:text-3xl lg:text-4xl">
            Every part of your clinic. <span className="text-brand">One connected platform.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p data-testid="overview-description" className="mt-6 text-base leading-relaxed text-slate-600">
            DENSA is an all-in-one dental clinic management software built by dentists, designed to simplify the
            everyday management of a dental practice. It brings patients, appointments, treatment and lab work,
            inventory, leads, finances, analytics, Google Reviews and Google Business Profile posts into one connected
            platform — so nothing lives in scattered spreadsheets, notebooks and apps anymore.
          </p>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Whether you run your clinic single-handedly, are starting your first practice, or are growing an
            established one — DENSA is built for dentists who want to spend more time practicing dentistry and living
            their lives, and less time struggling with clinic management.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <blockquote className="mt-8 border-l-4 border-brand pl-5 text-lg font-semibold leading-relaxed text-brand-ink">
            Know your real numbers. Know your clinic. Know where you&apos;re going.
            <span className="mt-1 block text-sm font-normal text-slate-500">No assumptions. No scattered systems. Just clarity.</span>
          </blockquote>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="overflow-hidden rounded-[2rem] shadow-xl shadow-brand/10">
          <img
            src="https://images.unsplash.com/photo-1608179665478-054e6786253b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY6Nzh8MHwxfHNlYXJjaHwzfHxkZW50aXN0JTIwc29mdHdhcmUlMjBhcHAlMjBjbGluaWN8ZW58MHx8fHwxNzg5MjE3MzAxfDA&ixlib=rb-4.1.0&q=85"
            alt="Dentist reviewing digital x-ray analysis on a laptop"
            className="aspect-[4/3] w-full object-cover"
            loading="lazy"
            data-testid="overview-image"
          />
        </div>
        <div className="absolute -bottom-6 -left-4 flex items-center gap-3 rounded-2xl border border-slate-100 bg-white px-4 py-3 shadow-xl sm:-left-8">
          <img src={SITE.assets.appIcon} alt="DENSA app icon" className="h-10 w-10 rounded-xl" />
          <span className="text-xs font-semibold text-brand-ink">
            DENSA for Android
            <span className="block text-[11px] font-normal text-slate-500">Your clinic, in your pocket</span>
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);

export default WhatIs;
